import { Injectable } from "@angular/core";

import { SearchProductsQuery } from "../../../common/generated-types";

type FacetItems = SearchProductsQuery["search"]["facetValues"];

export interface ProductListFacetCacheEntry {
    items: FacetItems;
    totalItems: number;
}

@Injectable({
    providedIn: "root",
})
export class ProductListViewCacheService {
    private readonly facets = new Map<string, ProductListFacetCacheEntry>();

    facetKey(
        collectionId: string | null,
        term: string,
        supplierId: string | null,
    ): string {
        return `${collectionId ?? ""}|${term}|${supplierId ?? ""}`;
    }

    getFacets(key: string): ProductListFacetCacheEntry | null {
        return this.facets.get(key) ?? null;
    }

    setFacets(key: string, entry: ProductListFacetCacheEntry): void {
        this.facets.set(key, entry);
    }
}
